<ol class="ps-3 mb-0">
  <li class="mb-3">
    <div class="fw-medium">Upload your flight records from the remote controller</div>
    <div class="small text-muted">
      On the controller, choose the operation mode (Agriculture or Lifting), select the drone's serial number, tap
      <em>Upload</em>, and select the flight records.
    </div>
  </li>

  <li class="mb-3">
    <div class="fw-medium">Authorize ADN on the DJI Agriculture platform</div>
    <div class="small text-muted">
      Log in at
      <a href="https://agms.dji.com" target="_blank" rel="noopener noreferrer">agms.dji.com</a>
      with the drone owner's account and open the <em>Regulatory Authority</em> page. Choose
      <em>Add Regulatory Authority</em>, enter ADN's authority email below, then select the drone or drones to share.
    </div>

    <div class="mt-2 p-2 rounded border bg-canvas d-flex align-items-center justify-content-between gap-2">
      <ng-container *ngIf="authorityEmail; else noAuthorityEmail">
        <code class="user-select-all" style="color: var(--text-primary)">{{ authorityEmail }}</code>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="copyEmail()">
          <i class="bi me-1" [ngClass]="copied() ? 'bi-check2' : 'bi-clipboard'"></i>{{ copied() ? 'Copied' : 'Copy' }}
        </button>
      </ng-container>
      <ng-template #noAuthorityEmail>
        <span class="small text-muted fst-italic">
          Contact ADN support for the authority email to enter ({{ supportPhone }}).
        </span>
      </ng-template>
    </div>
  </li>

  <li>
    <div class="fw-medium">To stop sharing, remove ADN</div>
    <div class="small text-muted">
      Remove ADN from the <em>Regulatory Authority</em> page at any time. Flights already received stay in your records.
    </div>
  </li>
</ol>

<p class="small text-muted mt-3 mb-0">
  After you authorize, new flights appear here once they have been uploaded from the controller. Detailed flight data can
  arrive a little after the flight summary.
</p>
